import { storePagination } from '@/mixins/store'
import axios from '@axios'
import moment from 'moment'

const getInitialState = () => ({
  ...storePagination.state(),
  filters: {
    storeId: null,
    checkingAccountId: null,
    period: {
      startDate: moment().add(-30, 'days').startOf('day').format(),
      endDate: moment().endOf('day').format(),
    },
  },
  statements: [],
  reportData: null,
})

export default {
  namespaced: true,
  state: getInitialState(),

  mutations: {
    ...storePagination.mutations,

    SET_STATEMENTS(state, statements) {
      state.statements = statements
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },
    SET_REPORT_DATA(state, reportData) {
      state.reportData = reportData
    },
    CLEAN_STATE(state) {
      const { filters, paging, statements } = getInitialState()
      state.filters = filters
      state.statements = statements
      state.paging = paging
    },
  },

  actions: {
    ...storePagination.actions,

    async fetchStatements({ commit, state }) {
      const { storeId, checkingAccountId, period } = state.filters

      const { startDate, endDate } = period

      const params = {
        storeId,
        checkingAccountId,
        pageSize: state.paging.pageSize,
        pageIndex: state.paging.currentPage - 1,
        initialDate: startDate,
        finalDate: endDate,
      }

      const { data } = await axios.get('/api/financial/internet-banking/accounts/statements', {
        params,
      })

      commit('SET_STATEMENTS', data.results || [])

      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },

    setFilters({ commit }, filters) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', filters)
    },

    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },

    async generateReport({ state, commit }) {
      const { storeId, checkingAccountId, period } = state.filters

      const { startDate, endDate } = period

      const params = {
        storeId,
        checkingAccountId,
        pageSize: state.paging.pageSize,
        pageIndex: state.paging.currentPage - 1,
        initialDate: startDate,
        finalDate: endDate,
      }

      const { data } = await axios.get(
        '/api/financial/internet-banking/accounts/statements/download',
        {
          params,
          responseType: 'blob',
        }
      )

      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      commit('SET_REPORT_DATA', url)
    },
  },
}
